import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useSafetyTranslation } from 'cng-common/features/translations'
import { PartnerSearchFilter } from 'partner360/components/partnerSearchFilter'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { setCockpitSelectedPartnerIds } from '../../../../model'
import {
  selectCockpitPartnerData,
  selectCockpitRtm,
  selectCockpitSelectedPartnerIds,
} from '../../../../model/selectors'
import { CockpitFilterLabel } from '../cockpitFilterLabel/CockpitFilterLabel'

import styles from './CockpitPartnerSearchFilter.module.scss'

const PLACEHOLDER_KEY = FINANCIAL_COCKPIT_TRANSLATION_KEYS.filterPanel.partnerSearchPlaceholder

export const CockpitPartnerSearchFilter = () => {
  const dispatch = useAppDispatch()
  const t = useSafetyTranslation()
  const partnerData = useSelector(selectCockpitPartnerData)
  const rtm = useSelector(selectCockpitRtm)
  const selectedPartnerIds = useSelector(selectCockpitSelectedPartnerIds)
  const partners = useMemo(
    () =>
      partnerData.filter((partner) =>
        rtm === 'resellers' ? partner.IsCommercial === 1 : partner.IsDistributor === 1
      ),
    [partnerData, rtm]
  )
  /** Only ids the current RTM still offers, so switching RTM cannot leave a stale chip behind. */
  const value = useMemo(
    () => selectedPartnerIds.filter((id) => partners.some((partner) => partner.PartnerId === id)),
    [partners, selectedPartnerIds]
  )
  const handleChange = useCallback(
    (partnerIds: string[]) => dispatch(setCockpitSelectedPartnerIds(partnerIds)),
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <CockpitFilterLabel text={PLACEHOLDER_KEY} placeholderOnly />
      <PartnerSearchFilter
        partners={partners}
        value={value}
        onChange={handleChange}
        placeholder={t(PLACEHOLDER_KEY)}
        withSearchIcon
      />
    </div>
  )
}
